var convert = require('./convert'),
    func = convert('trim', require('../trim'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ../~/lodash/fp/trim.js
// module id = 1778
// module chunks = 1